module.exports = __webpack_public_path__ + "static/media/externallink.e1444049.svg";